import {
	required,
	minValue,
	maxValue,
	minLength,
	maxLength,
	sameAs,
} from "vuelidate/lib/validators";

export const IceMixin = {
	validations: {
		melli_code: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},
		mobile_number: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
	},
};

export const baseRegisterMixin = {
	validations: {
		melliCode: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},
		password: {
			minLength: minLength(6),
			required,
		},
		rePassword: {
			required,
			sameAs: sameAs("password"),
		},
		name: {
			required,
		},
		lastName: {
			required,
		},
		fatherName: {
			required,
		},
		phone: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		province: {
			required,
		},
		city: {
			required,
		},
		address: {
			required,
		},
		gender: {
			required,
		},
	},
};

export const customerDataMixin = {
	validations: {
		job: {
			required,
		},
		jobClass: {
			required,
		},
		income: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(900)
		},
		zipCode: {
			required,
			checkZipCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999" ||
					code == "1234567890" ||
					code == "0123456789" ||
					code == "1234567899" ||
					code == "1122334455" ||
					code == "0987654321" ||
					code == "9876543210"
				)
					return false;
				else return true;
			},
		},
		is_organ: {
			required,
		},
	},
};

export const editFormMixin = {
	validations: {
		melliCode: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},

		name: {
			required,
		},
		lastName: {
			required,
		},
		fatherName: {
			required,
		},
		phone: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		province: {
			required,
		},
		city: {
			required,
		},
		address: {
			required,
		},
		job: {
			required,
		},
		jobClass: {
			required,
		},
		income: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(900)
		},
		zipCode: {
			required,
			checkZipCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999" ||
					code == "1234567890" ||
					code == "0123456789" ||
					code == "1234567899" ||
					code == "1122334455" ||
					code == "0987654321" ||
					code == "9876543210"
				)
					return false;
				else return true;
			},
		},
		// is_organ: {
		// 	required
		// }
	},
};
export const registerValidationMixin = {
	validations: {
		melliCode: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},

		name: {
			required,
		},
		lastName: {
			required,
		},
		fatherName: {
			required,
		},
		phone: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		// mobileNumber: {
		// 	required,
		// 	minLength: minLength(11),
		// 	maxLength: maxLength(11),
		// },
		province: {
			required,
		},
		city: {
			required,
		},
		address: {
			required,
		},
		job: {
			required,
		},
		jobClass: {
			required,
		},
		income: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(900)
		},
		zipCode: {
			required,

			checkZipCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999" ||
					code == "1234567890" ||
					code == "0123456789" ||
					code == "1234567899" ||
					code == "1122334455" ||
					code == "0987654321" ||
					code == "9876543210" ||
					code == "1212121212" ||
					code == "1234554321" ||
					code == "1231231231" ||
					code == "9876556789" ||
					code == "9879879879"
				)
					return false;
				else return true;
			},
		},
		gender: {
			required,
		},
	},
};

export const surtyValidationMixin = {
	validations: {
		melliCode: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},

		name: {
			required,
		},
		lastName: {
			required,
		},
		fatherName: {
			required,
		},
		phone: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		mobileNumber: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		province: {
			required,
		},
		city: {
			required,
		},
		address: {
			required,
		},
		job: {
			required,
		},
		jobClass: {
			required,
		},
		income: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(900)
		},
		zipCode: {
			required,

			checkZipCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999" ||
					code == "1234567890" ||
					code == "0123456789" ||
					code == "1234567899" ||
					code == "1122334455" ||
					code == "0987654321" ||
					code == "9876543210" ||
					code == "1212121212" ||
					code == "1234554321" ||
					code == "1231231231" ||
					code == "9876556789" ||
					code == "9879879879"
				)
					return false;
				else return true;
			},
		},
		gender: {
			required,
		},
	},
};

export const supplierCustomerValidationMixin = {
	validations: {
		melliCode: {
			required,
			checkMelliCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999"
				)
					return false;
				var check = parseInt(code[9]);
				var sum = 0;
				var i;
				for (i = 0; i < 9; ++i) {
					sum += parseInt(code[i]) * (10 - i);
				}
				sum %= 11;
				return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
			},
		},
		name: {
			required,
		},
		lastName: {
			required,
		},
		fatherName: {
			required,
		},
		phone: {
			required,
			minLength: minLength(11),
			maxLength: maxLength(11),
		},
		province: {
			required,
		},
		city: {
			required,
		},
		address: {
			required,
		},
		job: {
			required,
		},
		jobClass: {
			required,
		},
		income: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(900)
		},
		zipCode: {
			required,

			checkZipCode(code) {
				if (
					!/^\d{10}$/.test(code) ||
					code == "0000000000" ||
					code == "1111111111" ||
					code == "2222222222" ||
					code == "3333333333" ||
					code == "4444444444" ||
					code == "5555555555" ||
					code == "6666666666" ||
					code == "7777777777" ||
					code == "8888888888" ||
					code == "9999999999" ||
					code == "1234567890" ||
					code == "0123456789" ||
					code == "1234567899" ||
					code == "1122334455" ||
					code == "0987654321" ||
					code == "9876543210" ||
					code == "1212121212" ||
					code == "1234554321" ||
					code == "1231231231" ||
					code == "9876556789" ||
					code == "9879879879"
				)
					return false;
				else return true;
			},
		},
		is_organ: {
			required,
		},
		level: {
			required,
		},
		gender: {
			required,
		},
	},
};
